import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import useDesktopNavItems from 'components/nav/shared/data/useDesktopNavItems';
import DesktopNavCategoriesUI from './DesktopNavCategoriesUI';
const DesktopNavCategories = t0 => {
  const $ = _c(4);
  const {
    selectedCategoryId,
    setIsLinkHovered
  } = t0;
  const categoryNavItems = useDesktopNavItems();
  let t1;
  if ($[0] !== categoryNavItems || $[1] !== selectedCategoryId || $[2] !== setIsLinkHovered) {
    t1 = <DesktopNavCategoriesUI items={categoryNavItems} selectedCategoryId={selectedCategoryId} setIsLinkHovered={setIsLinkHovered} />;
    $[0] = categoryNavItems;
    $[1] = selectedCategoryId;
    $[2] = setIsLinkHovered;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
DesktopNavCategories.propTypes = {
  selectedCategoryId: PropTypes.string,
  setIsLinkHovered: PropTypes.func
};
export default DesktopNavCategories;